// a criteria is considered active if it has the active flag set to true,
// OR if it does not have an active flag at all
export const activeCriteriaFilter = criteria => criteria.filter(
  c => c.active || c.active === undefined
)

// legacy criteria are those only used prior to the update in the summer of 2022
export const isLegacyCriterionId = criterionId =>
  criterionId > 1 && criterionId < 5
export const isLegacyCriterion = criterion => isLegacyCriterionId(criterion.id)

// an assessment is considered legacy if it uses any legacy criteria
export const isLegacyAssessment = (assessment) =>
  assessment.criteria_responses.some(
    cr => isLegacyCriterionId(cr.artifact_assessment_criterium_id)
  )

// helper to identify the learning criterion, which has some special handling
export const isLearningCriterion = criterion => criterion.id === 1

export const getSimplifiedCriterionName = criterion => {
  switch (criterion.id) {
    case 3: return 'Effort'
    case 4: return 'Support'
    case 7: return 'Effort'
    default: return criterion.name
  }
}
